module.exports = __webpack_public_path__ + "static/img/zg_bg.2789d6db.png";